import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorRoutingModule } from './error-routing.module';
import { ErrorComponent } from './componets/error/error.component';
import { DefaultErrorHandler } from './default-error.handler';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ErrorRoutingModule,
  ],
  declarations: [
    ErrorComponent
  ],
  providers: [
    { provide: ErrorHandler, useClass: DefaultErrorHandler },
  ]
})
export class ErrorModule { }
